import type { JSX } from 'react';
import { Users } from 'lucide-react';

import { UserTable } from './user-table/user-table.js';

export function UsersView(): JSX.Element {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between border-b border-slate-800 pb-4">
        <div className="flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-cyan-950 text-cyan-400 ring-1 ring-cyan-800">
            <Users className="h-5 w-5" />
          </div>
          <div>
            <h2 className="text-lg font-semibold text-slate-100">
              Personel Ośrodka i Uprawnienia
            </h2>
            <p className="text-xs text-slate-400">
              Ewidencja tożsamości aplikacyjnych, zarządzanie dostępem do modułu finansowego oraz reset 2FA (Domena 1)
            </p>
          </div>
        </div>
      </div>

      <UserTable />
    </div>
  );
}
